<div data-theme="" class="lms-app-container app-wrapper">
  <main  class="content-area">
    <div class="card">
    <ng-content></ng-content>
    </div>
  </main>
</div>
